import { render, staticRenderFns } from "./ModalShippingAddress.vue?vue&type=template&id=64c05c2c&scoped=true&"
import script from "./ModalShippingAddress.vue?vue&type=script&lang=js&"
export * from "./ModalShippingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ModalShippingAddress.vue?vue&type=style&index=0&id=64c05c2c&prod&lang=scss&"
import style1 from "./ModalShippingAddress.vue?vue&type=style&index=1&id=64c05c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c05c2c",
  null
  
)

export default component.exports